<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Статистика продаж препарата (группировка по телефону)</h6>
      </div>
      <div class="card-body flex">
        <div class="form-group flex-grow-1">
          <label>Препарат</label>
          <DrugSearchNew
            ref="selectedDrug"
            :onSelect="selectDrug"
          />
        </div>
        <div class="form-group">
          <label>Мин.Кол. зявок</label>
          <input type="number" placeholder="Мин.Кол. зявок" v-model="minOrders" class="form-control">
        </div>
        <div class="form-group">
          <label>Кол. месяцев</label>
          <input type="number" placeholder="Кол. месяцев" v-model="months" class="form-control">
        </div>
        <div class="flex align_btn">
          <LoadingButton
            title='Показать'
            :loading="loading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => getData(1)"
            className="btn btn-outline-success btn-sm"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div>
          <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
          <table v-if="!loading && records" class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>Телефон</th>
              <th>
                <i
                  @click="sortRecords('firstOrder')"
                  :class="{
            'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sorting.firstOrder.direction === 'asc',
            'icon-fa-sort-amount-desc': sorting.firstOrder.direction !== 'asc'
          }"></i>
                Первая заявка
              </th>
              <th>заявки</th>
              <th>
                <i
                  @click="sortRecords('lastOrders')"
                  :class="{
            'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sorting.lastOrders.direction === 'asc',
            'icon-fa-sort-amount-desc': sorting.lastOrders.direction !== 'asc'
          }"></i>
                Крайняя заявка
              </th>
              <th>города</th>
              <th>Количество</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r.phone_id }}</td>
              <td>{{ r.phone }}</td>
              <td>{{ printDate(r.first_date, 'DD.MM.YYYY HH:mm', true) }}</td>
              <td>
                <a href="#"
                   @click.prevent="openInNewPage('searchOrder', {ordersId: r.orders})">
                  заявки ({{ r.orders.length }})
                </a>
              </td>
              <td>{{ printDate(r.last_date, 'DD.MM.YYYY HH:mm', true) }}</td>
              <td>
                <span class="mr-1" v-for="c in Object.keys(r.cities)">{{ sortedCities[c]?.short_name }}</span>
              </td>
              <td>{{ r.total_qty }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="paginator" class="text-right">
          <paginate
            v-model="paginator.current_page"
            :page-count="paginator.last_page"
            :page-range="10"
            :margin-pages="2"
            :click-handler="getData"
            :prev-text="'&laquo'"
            :next-text="'&raquo'"
            :container-class="'pagination'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import api from "@/api";
import Paginate from 'vuejs-paginate';
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {LoadingButton, DrugSearchNew, Paginate},
  data() {
    return {
      loading: false,
      months: 48,
      minOrders: null,
      drug: null,
      records: null,
      paginator: null,
      sortedCities: {},
      sorting: {
        firstOrder: {alias: 'first_date', isSorting: false, direction: 'asc'},
        lastOrders: {alias: 'last_date', isSorting: false, direction: 'asc'}
      }
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
  },
  created() {
    this.sortedCities = this.$AllCities.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
  },
  methods: {
    sortRecords(title = null) {
      if (!title) {
        title = Object.keys(this.sorting).find((t) => this.sorting[t].isSorting);
      } else {
        Object.keys(this.sorting).forEach((t) => {
          if (t !== title) {
            this.sorting[t].isSorting = false;
          }
        })
        this.sorting[title].isSorting = true;
        this.sorting[title].direction = this.sorting[title].direction === 'asc' ? 'desc' : 'asc';
      }
      this.records = _.orderBy(this.records, this.sorting[title].alias, this.sorting[title].direction);
      // this.getData();
    },
    selectDrug(drug) {
      this.drug = drug;
    },
    async getData(page = 1, resetSorting = false) {
      if (!this.drug || !this.months) return;
      this.loading = true;
      const {data} = await api.post('/statistics/sold/drug?page=' + page, {
        drug_id: this.drug.id,
        min_orders: this.minOrders,
        months: this.months,
        sorting: this.sorting[Object.keys(this.sorting).find((t) => this.sorting[t].isSorting)]
      })
      if (data.success) {
        this.records = _.orderBy(data.records, 'total_orders', 'desc');
        if (Object.keys(this.sorting).find((t) => this.sorting[t].isSorting)) {
          this.sortRecords();
        }
        this.paginator = data.pagination;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.form-group {
  margin-bottom: 0;
}

.align_btn button {
  align-self: end;
  height: 38px;
}

table.table td {
  padding: 2px 5px;
}
</style>
